import React, { useState } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import TrainingGoals from './components/TrainingGoals';
import Benefits from './components/Benefits';
import NutritionSection from './components/NutritionSection';
import FoodScanner from './components/FoodScanner';
import FinalCTA from './components/FinalCTA';
import Footer from './components/Footer';

function App() {
  const [lang, setLang] = useState('de');

  return (
    <div className="min-h-screen bg-white font-sans antialiased">
      <Header lang={lang} setLang={setLang} />
      <Hero lang={lang} />
      <TrainingGoals lang={lang} />
      <Benefits lang={lang} />
      <NutritionSection lang={lang} />
      <FoodScanner lang={lang} />
      <FinalCTA lang={lang} />
      <Footer />
    </div>
  );
}

export default App;
